export class BaseError extends Error {
  super(message: string) {
    this.message = message;
  }
}
